import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "table info-table" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = ["href", "textContent"]
const _hoisted_6 = { class: "text-center mb-4" }
const _hoisted_7 = {
  key: 2,
  class: "text-muted"
}

import ElCardHeader from "~/cabinet/vue/interface/card/ElCardHeader.vue";
import ElCardSection from "~/cabinet/vue/interface/card/ElCardSection.vue";
import Dictionary from "~/ts/library/Dictionary";
import {OperatorStatus} from "~/chat/ts/data/OperatorStatus";
import {getOperatorStatusDictionary, OperatorStatusInterface} from "~/operatorApplication/ts/data/OperatorStatus";
import StringHelper from "../../../ts/library/StringHelper";
import MyValues from "~/cabinet/vue/interface/data/MyValues.vue";
import MyValue from "~/cabinet/vue/interface/data/MyValue.vue";
import ElCardSectionWithTable from "~/cabinet/vue/interface/card/ElCardSectionWithTable.vue";
import {__} from "~/ts/library/Translate";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {computed} from "vue";


import {defineComponent} from "vue";

const __default__ = defineComponent({
    name: "CoreUiChatMessageInfoDialog"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    message: {},
    showOperatorLogins: { type: Boolean },
    operatorsDictionary: {},
    messageSourceTypeDictionary: {}
  }, {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  }),
  emits: ["update:visible"],
  setup(__props: any) {

let props = __props;

let isVisible = _useModel<boolean>(__props, "visible");
function close() {
    isVisible.value = false;
}

function getOperator(login: string) {
    return props.operatorsDictionary[login];
}

function getStatus(status: OperatorStatus): OperatorStatusInterface {
    return getOperatorStatusDictionary()[status] ?? {
        descr: status.toString(),
        statusId: status,
        colorClassName: "muted"
    };
}

let sourceType = computed(() => {
    if (props.messageSourceTypeDictionary) {
        return props.messageSourceTypeDictionary[props.message.source?.typeId];
    }
    return null;
});


return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _unref(__)(`Информация о сообщении`) + `. id - ${_unref(props).message.id}`,
    modelValue: _unref(isVisible),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isVisible) ? (isVisible).value = $event : isVisible = $event)),
    width: "800px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, { class: "el-row-root" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, null, {
            default: _withCtx(() => [
              (_unref(props).message.senderInfo.ip || _unref(props).message.senderInfo.useragent || _unref(props).message.senderInfo.page || _unref(props).message.source)
                ? (_openBlock(), _createBlock(_component_el_card, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(ElCardHeader, {
                        title: _unref(__)('Информация об отправителе')
                      }, null, 8, ["title"]),
                      _createVNode(ElCardSectionWithTable, null, {
                        default: _withCtx(() => [
                          _createElementVNode("table", _hoisted_1, [
                            (_unref(props).message.senderInfo.ip)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
                                  _cache[1] || (_cache[1] = _createElementVNode("td", null, " IP ", -1)),
                                  _createElementVNode("td", null, _toDisplayString(_unref(props).message.senderInfo.ip), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(props).message.senderInfo.useragent)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                                  _cache[2] || (_cache[2] = _createElementVNode("td", null, " User-Agent ", -1)),
                                  _createElementVNode("td", null, _toDisplayString(_unref(props).message.senderInfo.useragent), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(props).message.senderInfo.page)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                                  _cache[3] || (_cache[3] = _createElementVNode("td", null, " Страница сайта ", -1)),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("a", {
                                      href: _unref(props).message.senderInfo.page.url,
                                      textContent: _toDisplayString(_unref(props).message.senderInfo.page.title),
                                      target: "_blank"
                                    }, null, 8, _hoisted_5)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(props).message.source)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  _createElementVNode("tr", null, [
                                    _cache[4] || (_cache[4] = _createElementVNode("td", null, "Источник сообщения", -1)),
                                    _createElementVNode("td", null, [
                                      (_unref(sourceType))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createVNode(FontAwesomeIcon, {
                                              icon: _unref(sourceType).icon,
                                              class: "mr-1"
                                            }, null, 8, ["icon"]),
                                            _createTextVNode(" " + _toDisplayString(_unref(sourceType).descr), 1)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode(_toDisplayString(_unref(props).message.source.typeId), 1)
                                          ], 64))
                                    ])
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(props).message.source.info, (row) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                      _createElementVNode("td", null, _toDisplayString(row.key), 1),
                                      _createElementVNode("td", null, _toDisplayString(row.value), 1)
                                    ]))
                                  }), 256))
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(props).message.operatorsStatus.length)
                ? (_openBlock(), _createBlock(_component_el_card, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(ElCardHeader, {
                        title: _unref(__)('Статус операторов в момент отправки сообщения')
                      }, null, 8, ["title"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(props).message.operatorsStatus, (operator) => {
                        return (_openBlock(), _createBlock(ElCardSection, {
                          key: operator.login
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h5", _hoisted_6, [
                              (getOperator(operator.login))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(getOperator(operator.login).fio), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" Оператор не найден ")
                                  ], 64)),
                              (__props.showOperatorLogins)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, " / " + _toDisplayString(operator.login), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(MyValues, null, {
                              default: _withCtx(() => [
                                _createVNode(MyValue, {
                                  label: _unref(__)('Статус'),
                                  span: 6,
                                  "font-weight-normal": "",
                                  uppercase: false,
                                  color: getStatus(operator.status).colorClassName
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(StringHelper).capitalize(getStatus(operator.status).descr)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "color"]),
                                _createVNode(MyValue, {
                                  label: _unref(__)('Виден клиенту'),
                                  span: 6,
                                  "font-weight-normal": "",
                                  uppercase: false,
                                  color: operator.isVisibleForClient ? 'success' : 'danger'
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(operator.isVisibleForClient ? _unref(__)("Да") : _unref(__)("Нет")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "color"]),
                                _createVNode(MyValue, {
                                  label: _unref(__)('Выходной'),
                                  span: 6,
                                  "font-weight-normal": "",
                                  uppercase: false,
                                  color: operator.isWorkingNow ? 'muted' : 'status-999'
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(!operator.isWorkingNow ? _unref(__)("Да") : _unref(__)("Нет")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "color"]),
                                _createVNode(MyValue, {
                                  label: _unref(__)('Недоступен из-за ограничений лицензии'),
                                  span: 6,
                                  "font-weight-normal": "",
                                  uppercase: false,
                                  color: operator.isUnavailableBecauseOfLicenseLimits ? 'danger' : 'muted'
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(operator.isUnavailableBecauseOfLicenseLimits ? _unref(__)("Да") : _unref(__)("Нет")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "color"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})